import React, { Component, Fragment } from "react";
import alasql from "alasql";
import TableHolder from "./section1/tableHolder";
import DrillDownHolder from "./section1/drillDownHolder";
import Button from "../../../parts/pdfmaker/common/Button";
import WithCard from "../../../common/withCard";
import PDFHelper from "../../../parts/pdfmaker/pdf.helper";
import PdfHeader from "../../../parts/pdfmaker/common/pdfHeader";
import PDFTable from "../../../parts/pdfmaker/common/pdfTable";
import { Image as IMG, View, Document, Page, pdf } from "@react-pdf/renderer";

class RebalanceHolder extends Component {
  _isMounted = false;
  state = {
    heading: [],
    cols: [],
    lastLivePort: [],
    lastCurrPort: [],
  };
  componentDidMount() {
    this._isMounted = true;
    const { live, current } = this.props;
    this.modifyData({ live: live, current: current });
  }
  componentWillReceiveProps(nextProps) {
    const { live, current } = nextProps;
    if (
      JSON.stringify(live) != JSON.stringify(this.props.live) ||
      JSON.stringify(current) != JSON.stringify(this.props.current)
    ) {
      this.setState({
        lastLivePort: [],
        lastCurrPort: [],
      });
      this.modifyData({ live: live, current: current });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  modifyData = ({ live, current } = []) => {
    if (live.length && current.length) {
      let lastLiveDate = alasql("SELECT dt FROM ? ORDER BY dt DESC LIMIT 1", [
        live,
      ]);
      let lastCurrDate = alasql("SELECT dt FROM ? ORDER BY dt DESC LIMIT 1", [
        current,
      ]);
      if (lastLiveDate.length !== 0) {
        var lastLivePort = alasql(
          "SELECT * FROM ? WHERE dt = '" + lastLiveDate[0].dt + "'",
          [live]
        );
      }
      if (lastCurrDate.length !== 0) {
        var lastCurrPort = alasql(
          "SELECT * FROM ? WHERE dt = '" + lastCurrDate[0].dt + "'",
          [current]
        );
      }
      let distinct = alasql("SELECT DISTINCT symbol FROM ?", [
        [...live, ...current],
      ]);
      let cols = [];

      for (let i in distinct) {
        let line = distinct[i];
        let ac = "";
        let symbol = "";
        let liveW = "";
        let currW = "";
        let live = alasql(
          "SELECT * FROM ? WHERE symbol = '" + line.symbol + "'",
          [lastLivePort]
        );
        let curr = alasql(
          "SELECT * FROM ? WHERE symbol = '" + line.symbol + "'",
          [lastCurrPort]
        );

        if (live.length) {
          ac = live[0].fund_asset_class_focus;
          symbol = live[0].symbol;
          liveW = live[0].allocation + "%";
        }

        if (curr.length) {
          ac = !ac.length ? curr[0].fund_asset_class_focus : ac;
          symbol = !symbol.length ? curr[0].symbol : symbol;
          currW = curr[0].allocation + "%";
        }

        if (live.length || curr.length)
          cols.push([ac, symbol, liveW || "-", currW || "-"]);
      }

      this.setState({
        cols: cols,
        heading: [
          { title: "Asset Class" },
          { title: "Symbol" },
          { title: lastLiveDate[0].dt },
          { title: lastCurrDate[0].dt },
        ],
        lastLivePort,
        lastCurrPort,
      });
    }
  };

  Error = () => {
    return (
      <div
        className="text-uppercase bold text-center"
        style={{ paddingTop: "15px" }}
      >
        <h4>No data to display</h4>
      </div>
    );
  };
  exportPDF = () => {
    const { cols, heading } = this.state;
    Promise.all([
      PDFHelper.svgToPng("Drill_Rebal_01"),
      PDFHelper.svgToPng("Drill_Rebal_02"),
    ]).then((values) => {
      const MyDoc = () => (
        <Document>
          <Page size="A4" wrap>
            <PdfHeader
              mainHeading={this.props.heading + " - " + "REBALANCE"}
              greyHeading={true}
            />
            <View style={{ paddingHorizontal: 35 }}>
              <View style={{ display: "flex", flexDirection: "row" }}>
                <View style={{ width: "50%" }}>
                  <View>
                    <IMG source={values[0]}></IMG>
                  </View>
                </View>

                <View style={{ width: "50%" }}>
                  <View>
                    <IMG source={values[1]} style={{ padding: 5 }}></IMG>
                  </View>
                </View>
              </View>
              <View style={{ marginTop: 30 }}>
                <PDFTable data={cols} heading={heading} Width={"25%"} />
              </View>
            </View>
          </Page>
        </Document>
      );

      pdf(<MyDoc />)
        .toBlob()
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "rebalance.pdf";
          document.body.append(link);
          link.click();
          link.remove();
        });
    });
  };
  render() {
    const { cols, heading, lastLivePort, lastCurrPort } = this.state;

    return (
      <Fragment>
        {lastLivePort.length > 0 && lastCurrPort.length > 0 ? (
          <Fragment>
            <WithCard>
              <div className="row">
                <div
                  className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                  style={{ display: "flex", float: "right" }}
                >
                  <Button exportPDF={this.exportPDF} marginLeft={"auto"} />
                </div>
              </div>
            </WithCard>
            <div className="row">
              <DrillDownHolder
                lastLivePort={lastLivePort}
                lastCurrPort={lastCurrPort}
                id1="Drill_Rebal_01"
                id2="Drill_Rebal_02"
              />
            </div>
            {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12"> */}
            <div>
              <WithCard>
                <div className="row">
                  <TableHolder cols={cols} heading={heading} />
                </div>
              </WithCard>
              {/* </div> */}
            </div>
          </Fragment>
        ) : (
          this.Error()
        )}
      </Fragment>
    );
  }
}

export default RebalanceHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Rebalance/rebalanceHolder.jsx